module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('find-stats'), " ", (page === PAGE_UNSUPPORTED) ? _h('find-modal', [_h('find-unsupported')]) : _e(), " ", (page === PAGE_WELCOME) ? _h('find-modal', [_h('find-welcome')]) : _e(), " ", (page === PAGE_CONGRATULATIONS) ? _h('find-modal', {
    attrs: {
      "wide": ""
    }
  }, [_h('find-congratulations')]) : _e(), " ", (page === PAGE_GAME) ? _h('find-game') : _e(), " ", _h('find-footer')])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-314ae974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 165
 ** module chunks = 2
 **/